/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import {useEffect, useState} from "react";
import {FECHACHECKIN} from "../../../Modulo_Motor_Reservas/Constantes";
import IngresoImagenCropLista from "../../../Modulo_formularios/Componentes/IngresoImagenCropLista";

const Formulario_Habitaciones_Detalles = ({...props}) => {
    const [fechaInicio, setFechaInicio] = useState(new Date())


    useEffect(() => {
        let fechaEscogida = props.props.getValues(FECHACHECKIN)
        setFechaInicio(fechaEscogida)


    }, [props.props.watch(FECHACHECKIN)]);
    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Detalles'} dato={'detalles'} {...props}/>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoImagenCropLista dato={'imgs'} {...props} ancho={1} alto={1}/>
                </Grid>

            </Grid>

        </form>

    )

}
export default Formulario_Habitaciones_Detalles